<app-integration
    [widgetRef]="widgetRef"
    [integrationInput]="integrationInput"
    [isConfigured]="isConfigured"
    (onIntegrate)="onIntegrate(formGenInput)"
    [description]="widgetRef.widgetDescription"
></app-integration>
